<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext consent">
      <div class="container">
        <div class="area_wrap">
          <div class="consentTitle">
          <h2>수술동의서는</h2>
          <h2>아래와 같은 내용으로</h2>
          <h2>구성됩니다.</h2>
          </div>
          <div class="paragraphComplex">
            <p><b>1.</b><span>환자의 병력 및 기저질환, 수술 이력 기록</span></p>
            <p><b>2.</b><span>설명사항</span></p>
            <p class="gray"><b>가.</b><span>수술의 목적 및 효과</span></p>
            <p class="gray"><b>나.</b><span>수술과정 및 방법, 수술부위 및 추정 소요시간</span></p>
            <p class="gray"><b>다.</b><span>수술 이후에 나타날 수 있는 합병증(후유증)의 내용, 정도 및 대처방법</span></p>
            <p class="gray"><b>라.</b><span>수술관련 주의사항</span></p>
            <p class="pre"><b>마.</b><span>수술방법 및 수술의사 변경과 수술 범위 추가 가능성</span></p>
            <p class="pre"><b>바.</b><span>조직검사 관련 사항</span></p>
            <p class="pre"><b>사.</b><span>전신마취 설명사항</span></p>
            <p><b>3.</b><span>설명의사의 서명</span></p>
            <p><b>4.</b><span>환자/대리인의 서명</span></p>
          </div>
          <div class="surgerySection">
            <div class="item">
            <h6 class="title">가~라 항목은 진단이나 수술명에 따라 다릅니다.</h6>
            <router-link to="/surgery/surgeryConsentList">
              <button type="button">수술명에 따른 상세 내용 보기</button>
            </router-link>
            </div>
            <div class="item">
              <h6 class="title">가~라 항목은 진단이나 수술명에 따라 다릅니다.</h6>
              <div class="itemBtn">
                <a href="https://drive.google.com/file/d/1WGcOp9HK5Xh643NdE272qM-GDFxnUHPn/view?usp=sharing" target="_blank">
                  <button type="button" class="small">공통 항목 내용 보기</button>
                </a>
              </div>
              <div class="itemBtn">
                <a href="https://drive.google.com/file/d/1Caio0U-2XDruhSuFY2AIwoOwmCIdHiDK/view?usp=sharing" target="_blank">
                  <button type="button">실제 수술 동의서 샘플 보기</button>
                </a>
              </div>
            </div>
          </div>
          <div class="paragraphComplex">
          <p>실제 동의서 작성은 '수술을 집도할 전문의' 로부터 직접 설명을 듣고 서명하게 됩니다.</p>
            <p>(대학병원(교육병원)처럼 수술을 잘 모르는 전공의(레지던트)가 설명하지 않습니다.)</p>
            <p>여기 있는 동의서들은 병원에서 실제 작성하는 동의서와 양식이나 내용에 다소 차이가 있을 수 있습니다.</p>
            <p>땡큐서울의원는 안전하고 정확한 수술을 위해 항상 최선을 다합니다.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
export default {
  data () {
    return {
      transDate: {
        headerName: '수술 동의서 소개',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>

</style>
